import { render } from "./FooterView.vue?vue&type=template&id=58a00dca&scoped=true"
import script from "./FooterView.vue?vue&type=script&lang=js"
export * from "./FooterView.vue?vue&type=script&lang=js"

import "./FooterView.vue?vue&type=style&index=0&id=58a00dca&lang=scss&scoped=true"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a00dca"]])

export default __exports__